import { ConditionalPartial } from '../../../../utils';

import { CreateTempExcursionPostReleaseConfigRequestDto } from './create-temp-excursion-post-release-config.request.dto';

/**
 * DTO for updating temperature excursion post-release configuration
 * All fields are optional for partial updates
 */
export class UpdateTempExcursionPostReleaseConfigRequestDto extends ConditionalPartial(
    CreateTempExcursionPostReleaseConfigRequestDto,
) {}
